import PropTypes from "prop-types";
import styled from "styled-components";
import { PADDING_LEFT } from "./../constants";

export const StyledRowOptimization = styled.div`
  background-color: var(--color-contrast-white);
  width: 100%;
  padding-left: ${PADDING_LEFT}px;
  position: relative;
  min-height: 56px;

  :not(:last-child) {
    border-bottom: 1px solid var(--color-neutral-background);
  }

  :hover {
    background: #d9e8f2;
  }

  ${(p) =>
    p.isExpanded &&
    p.hasChildren &&
    `
      &:before {
        content: '';
        position: absolute;
        left: 12px;
        top: 8px;
        bottom: 0;
      }
    `} .etb-info {
    display: flex;
    box-sizing: border-box;
  }

  .etb-column:not(:last-child), .etb-label {
    border-right: 1px solid #dbdbdb;
  }
  
  .etb-image-alert {
    margin-right: 4px;
  }

  .etb-children {
    display: none;
    flex-direction: column;
    
    &.expanded {
      display: flex;

    > div {
    position: relative;
    background: #AACDFC;
    padding-left: ${PADDING_LEFT}px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 8px;
      bottom: 8px;
      width: 4px;
      background: #0057C9;
      border-radius: 999px;
      margin-left:10px;
    }
    }
    }
  }
`;

StyledRowOptimization.propTypes = {
  isExpanded: PropTypes.bool,
  hasChildren: PropTypes.bool,
};
